<template lang="pug">
  .container-navibuttons
    el-button.menu-button.tags(
      id="DeviceNaviButtons-toggleTagFilter",
      type="text",
      :title="$t('Toggle Tag Filter')",
      :class="{ active: tagFilterActive }",
      @click="toggleTagFilterVisibility()"
    )
      font-awesome-icon(icon="tags")
    el-button.menu-button(
      v-if="this.$router.history.current.params.rightPanel ===  'screenGroups' || this.$router.history.current.params.rightPanel ===  'deviceHealthReport'",
      id="DeviceNaviButtons-screenList",
      type="text",
      :title="$t('Screen list')",
      :class="{ active: this.$router.history.current.params.rightPanel ===  'devices' }",
      @click="openScreens()"
    )
      font-awesome-icon(icon="bars")
    el-button.menu-button(
      v-if="this.$router.history.current.params.rightPanel ===  'devices'",
      type="text",
      id="DeviceNaviButtons-locations",
      :title="$t('Locations')",
      :class="{ active: this.$router.history.current.params.rightPanel ===  'screenGroups' }",
      @click="openScreenGroups()"
    )
      font-awesome-icon(icon="map-marked-alt")
    el-button.menu-button.button-sync(
      id="DeviceNaviButtons-reload",
      type="text",
      :class="{ 'active': reloadingDevices, 'fa-spin': reloadingDevices }"
      @click="reloadRightComponent()",
      :title="$t('Reload')"
    )
      font-awesome-icon(icon="sync")
</template>

<script>
import UpdateContentToStartReportList from './UpdateContentToStartReportList'

export default {
  props: ['side'],
  components: {
    UpdateContentToStartReportList
  },
  methods: {
    toggleTagFilterVisibility () {
      this.$store.dispatch('Device/toggleTagFilterVisible')
    },
    openScreens () {
      this.$store.commit('Device/SET_DESKTOPS_COMPONENT_RIGHT', 'devices')
      this.$router.push({ path: '/layout-full/' + this.$route.params.leftPanel + '/devices' + '/' + this.$route.params.mediumEditor })
    },
    openDeviceHealthReport () {
      this.$store.commit('Device/SET_DESKTOPS_COMPONENT_RIGHT', 'deviceHealthReport')
      this.$router.push({ path: '/layout-full/' + this.$route.params.leftPanel + '/deviceHealthReport' + '/' + this.$route.params.mediumEditor })
    },
    openScreenGroups () {
      this.$store.commit('Device/SET_DESKTOPS_COMPONENT_RIGHT', 'screenGroups')
      this.$router.push({ path: '/layout-full/' + this.$route.params.leftPanel + '/screenGroups' + '/' + this.$route.params.mediumEditor })
    },
    reloadRightComponent () {
      this.$emit('reloadRightComponent')
    }
  },
  computed: {
    reloadingDevices () {
      return this.$store.state.Device.devices_reloading
    },
    tagFilterActive () {
      return this.$store.state.Device.device_filter[this.side].deviceTags.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-navibuttons {
  margin-right: -11px;
}
.menu-button, .left-menu-dropdown-icon {
  font-size: 20px;
  color: $--color-text-primary;
  &:hover {
    color: $--color-primary;
  }
  &.active-filter, &.active {
    color: $--color-warning;
  }
  &.tags {
    font-size: 16px;
  }
}
.menu-button  {
  padding: 10px 5px;
  &.button-sync, &.button-actions {
    opacity: 0.3;
    color: $--color-text-primary;
    &.active {
      opacity: 1;
    }
  }
}
.left-menu-dropdown-icon {
  margin-top: -5px;
  padding: 0px 10px 0px 10px;
}
.el-icon-loading {
  line-height: 40px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/NaviButtons.vue